package app.nestbridge.domain.identity.service

import app.nestbridge.domain.identity.api.model.ProfessionalProfileDto
import app.nestbridge.domain.identity.api.model.ProfessionalServiceTypeDto
import app.nestbridge.domain.identity.api.model.UserDto
import app.nestbridge.domain.identity.api.model.UserProfileDto
import app.nestbridge.domain.identity.api.model.UserStatusDto
import app.nestbridge.domain.identity.model.ProfessionalProfile
import app.nestbridge.domain.identity.model.ProfessionalServiceType
import app.nestbridge.domain.identity.model.User
import app.nestbridge.domain.identity.model.UserProfile
import app.nestbridge.domain.identity.model.UserStatus

internal fun UserDto.toDomain(): User = User(
    id = id,
    identityId = identityId,
    emails = emails,
    phoneNumbers = phoneNumbers,
    status = status.toDomain(),
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun User.toDto(): UserDto = UserDto(
    id = id,
    identityId = identityId,
    emails = emails,
    phoneNumbers = phoneNumbers,
    status = status.toDto(),
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun UserStatusDto.toDomain(): UserStatus = when (this) {
    UserStatusDto.ACTIVE -> UserStatus.Active
    UserStatusDto.SUSPENDED -> UserStatus.Suspended
    UserStatusDto.DELETED -> UserStatus.Archived
}

internal fun UserStatus.toDto(): UserStatusDto = when (this) {
    UserStatus.Active -> UserStatusDto.ACTIVE
    UserStatus.Suspended -> UserStatusDto.SUSPENDED
    UserStatus.Archived -> UserStatusDto.DELETED
}

internal fun UserProfileDto.toDomain(): UserProfile = UserProfile(
    id = id,
    userId = userId,
    fullName = fullName,
    displayName = displayName,
    profilePictureUrl = profilePictureUrl,
    locale = locale,
    timezone = timezone,
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun UserProfile.toDto(): UserProfileDto = UserProfileDto(
    id = id,
    userId = userId,
    fullName = fullName,
    displayName = displayName,
    profilePictureUrl = profilePictureUrl,
    locale = locale,
    timezone = timezone,
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun ProfessionalProfileDto.toDomain(): ProfessionalProfile = ProfessionalProfile(
    id = id,
    userId = userId,
    displayName = displayName,
    credentials = credentials,
    affiliation = affiliation,
    primaryServiceProvided = primaryServiceProvided.toDomain(),
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun ProfessionalProfile.toDto(): ProfessionalProfileDto = ProfessionalProfileDto(
    id = id,
    userId = userId,
    displayName = displayName,
    credentials = credentials,
    affiliation = affiliation,
    primaryServiceProvided = primaryServiceProvided.toDto(),
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun ProfessionalServiceTypeDto.toDomain(): ProfessionalServiceType = when (this) {
    ProfessionalServiceTypeDto.SpeechLanguageTherapy -> ProfessionalServiceType.SpeechLanguageTherapy
    ProfessionalServiceTypeDto.OccupationalTherapy -> ProfessionalServiceType.OccupationalTherapy
    ProfessionalServiceTypeDto.PhysicalTherapy -> ProfessionalServiceType.PhysicalTherapy
    ProfessionalServiceTypeDto.DevelopmentalTherapy -> ProfessionalServiceType.DevelopmentalTherapy
    ProfessionalServiceTypeDto.AppliedBehaviorAnalysis -> ProfessionalServiceType.AppliedBehaviorAnalysis
    ProfessionalServiceTypeDto.FeedingTherapy -> ProfessionalServiceType.FeedingTherapy
    ProfessionalServiceTypeDto.MentalHealthCounseling -> ProfessionalServiceType.MentalHealthCounseling
    ProfessionalServiceTypeDto.Psychology -> ProfessionalServiceType.Psychology
    ProfessionalServiceTypeDto.SocialWork -> ProfessionalServiceType.SocialWork
    ProfessionalServiceTypeDto.EarlyChildhoodEducation -> ProfessionalServiceType.EarlyChildhoodEducation
    ProfessionalServiceTypeDto.VisionServices -> ProfessionalServiceType.VisionServices
    ProfessionalServiceTypeDto.HearingAudiology -> ProfessionalServiceType.HearingAudiology
    ProfessionalServiceTypeDto.Other -> ProfessionalServiceType.Other
}

internal fun ProfessionalServiceType.toDto(): ProfessionalServiceTypeDto = when (this) {
    ProfessionalServiceType.SpeechLanguageTherapy -> ProfessionalServiceTypeDto.SpeechLanguageTherapy
    ProfessionalServiceType.OccupationalTherapy -> ProfessionalServiceTypeDto.OccupationalTherapy
    ProfessionalServiceType.PhysicalTherapy -> ProfessionalServiceTypeDto.PhysicalTherapy
    ProfessionalServiceType.DevelopmentalTherapy -> ProfessionalServiceTypeDto.DevelopmentalTherapy
    ProfessionalServiceType.AppliedBehaviorAnalysis -> ProfessionalServiceTypeDto.AppliedBehaviorAnalysis
    ProfessionalServiceType.FeedingTherapy -> ProfessionalServiceTypeDto.FeedingTherapy
    ProfessionalServiceType.MentalHealthCounseling -> ProfessionalServiceTypeDto.MentalHealthCounseling
    ProfessionalServiceType.Psychology -> ProfessionalServiceTypeDto.Psychology
    ProfessionalServiceType.SocialWork -> ProfessionalServiceTypeDto.SocialWork
    ProfessionalServiceType.EarlyChildhoodEducation -> ProfessionalServiceTypeDto.EarlyChildhoodEducation
    ProfessionalServiceType.VisionServices -> ProfessionalServiceTypeDto.VisionServices
    ProfessionalServiceType.HearingAudiology -> ProfessionalServiceTypeDto.HearingAudiology
    ProfessionalServiceType.Other -> ProfessionalServiceTypeDto.Other
}
